import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FooterAddressSharedComponent } from './footer.address.component';

@NgModule({
    declarations: [
        FooterAddressSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        FooterAddressSharedComponent
    ]
})

export class FooterAddressSharedModule {}
